import { translate } from '../../../utils/mundialUtils';

export const getStatusMatch = (status, translations) => {
  switch (status) {
    case 'SCHEDULED':
      return translate('matches_result_later_label', translations);

    case 'IN_PROGRESS':
      return translate('matches_result_now_label', translations);

    case 'COMPLETED':
      return translate('matches_result_finalized_label', translations);

    default:
      return '';
  }
};


export const getNationPlaceholder = (roundId, team, translations) => {
  if (roundId === 'GNFPAYWC9M394J5') {
    return `Equipo ${team.names.abbreviation}`;
  }

  return translate('matches_result_toDefine_label', translations);
};
